/**
 * 실제로 보이는 화면 높이를 CSS 변수 `--app-height` 로 넣는다.
 *
 * ★ **인앱 브라우저에서 스크롤이 막히던 문제.** (2026-09-15, 카카오톡 공유 링크)
 *
 *   이 앱은 `body` 를 화면 높이에 고정하고(`overflow: hidden`) 안쪽 `.section` 만
 *   스크롤한다. 높이를 CSS 단위로만 잡으면 인앱 브라우저에서 두 가지로 깨진다.
 *
 *   - `100vh` 는 하단 버튼 줄까지 포함한 높이라, 아래쪽이 버튼 줄 밑으로 잘린다.
 *   - `100dvh` 를 모르는 웹뷰에서는 선언이 통째로 무시된다. `.page` 높이가 풀리면
 *     `.section` 이 내용 길이만큼 늘어나 **안쪽 스크롤도 생기지 않고**, `body` 가
 *     넘친 부분을 잘라 버린다.
 *
 *   `window.innerHeight` 는 지금 실제로 보이는 높이라 두 경우 모두 맞다. 스타일은
 *   `var(--app-height, 100dvh)` 처럼 이 값을 먼저 쓰고, 스크립트가 돌기 전에는 원래
 *   단위로 물러난다(`_overrides.scss`).
 */
export function watchAppHeight(): void {
  const root = document.documentElement;

  const apply = () => {
    root.style.setProperty('--app-height', `${window.innerHeight}px`);
  };

  apply();
  // 화면 회전, 주소창·버튼 줄이 접히고 펼쳐질 때 높이가 바뀐다.
  window.addEventListener('resize', apply);
  window.addEventListener('orientationchange', apply);
}
